import * as R from 'ramda';

const truncate = (limit) =>
  R.when(R.propSatisfies(R.gt(R.__, limit), 'length'), R.pipe(R.take(limit), R.append('…'), R.join('')));

export default truncate;
